// DEPENDENCIES
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
// CUSTOM COMPONENTS
import Section from '../components/Section';
import ContentBlock from '../components/ContentBlock';
// PARTIALS
import JobListBlock from '../pages/dashboard/_partials/JobListBlock';
// import JobTeamMembersBlock from '../pages/dashboard/_partials/JobTeamMembersBlock';
// import JobDaysCounterBlock from '../pages/dashboard/_partials/JobDaysCounterBlock';
// import JobFinancialsBlock from '../pages/dashboard/_partials/JobFinancialsBlock';
// import JobTasksBlock from '../pages/dashboard/_partials/JobTasksBlock';
import JobCalendarBlock from '../pages/dashboard/_partials/JobCalendarBlock';
import QuickBooksData from '../pages/dashboard/_partials/QuickBooksData';
import JobFinancialsSnapShotBlock from '../pages/dashboard/_partials/JobFinancialsSnapShotBlock';
import JobLocationsAndMapsBlock from '../pages/dashboard/_partials/JobLocationsAndMapsBlock';
//SERVICES AND HELPERS
import * as dashboardService from "../../services/dashboard/dashboardService";

const DashboardPage = (props) => {
  const { auth } = props;
  const [jobs, setJobs] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [selectedJobNumber, setSelectedJobNumber] = useState("");

  useEffect(() => {
    fetchAllJobs();
  }, []);

  const fetchAllJobs = () => {
    dashboardService.getAllJobs().then(res => {
      setJobs(res);
    });
  }

  return (
    <>
      <Section removeContainer>
        <ContentBlock cols={3} className="job-list-block-spacing">
          <JobListBlock jobs={jobs} setSelectedJobId={setSelectedJobId} setSelectedJobNumber={setSelectedJobNumber} />
        </ContentBlock>

        <ContentBlock cols={9} className="large-card-spacing">
          <JobCalendarBlock/>
        </ContentBlock>

        <ContentBlock cols={7} className="large-card-spacing" style={{ height: '500px !important'}}>
          <JobFinancialsSnapShotBlock />
        </ContentBlock>

        <ContentBlock cols={5} className="large-card-spacing">
          <JobLocationsAndMapsBlock />
        </ContentBlock>
        
        {
          auth && auth.user && Object.keys(auth.user).length > 0 &&  (auth.user.username === 'admin' || auth.user.username === 'Chip') &&
        <ContentBlock cols={12} className="large-card-spacing">
          <QuickBooksData />
        </ContentBlock>
        }
 

        {/* <ContentBlock cols={3} className="job-list-block-spacing">
          <JobListBlock jobs={jobs} setSelectedJobId={setSelectedJobId} setSelectedJobNumber={setSelectedJobNumber}/>
        </ContentBlock>

        <ContentBlock cols={8}>
          <Section removeContainer>
            <ContentBlock cols={6} className="large-card-spacing">
              <JobTeamMembersBlock selectedJobId={selectedJobId} />
            </ContentBlock>

            <ContentBlock cols={6} className="large-card-spacing">
              <JobDaysCounterBlock selectedJobId={selectedJobId} />
            </ContentBlock>

            <ContentBlock cols={12} className="large-card-spacing">
              <JobFinancialsBlock selectedJobId={selectedJobId} selectedJobNumber={selectedJobNumber}/>
            </ContentBlock>

            <ContentBlock cols={6} className="large-card-spacing">
              <JobTasksBlock />
            </ContentBlock>
          </Section>
        </ContentBlock> */}
      </Section>

    </>
  )
}

const mapStateToProps = (state) => ({
  auth: state.auth
})

export default connect(mapStateToProps, null)(DashboardPage);

